import { render, staticRenderFns } from "./page-share.vue?vue&type=template&id=4852abee&scoped=true"
import script from "./page-share.vue?vue&type=script&lang=ts"
export * from "./page-share.vue?vue&type=script&lang=ts"
import style0 from "./page-share.vue?vue&type=style&index=0&id=4852abee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4852abee",
  null
  
)

export default component.exports